import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from 'react';
import { Select } from '@vtblife/uikit';
import axios from '@vtblife/axios';
import styles from './region-suggest.module.css';
import { InputControl } from './input-control';
import { useDebounce } from '../../../utils/use-debounce';
import { geoApiService } from '../../../utils/geo-api';
var DEBOUNCE_DELAY = 300;
export var RegionSuggest = function RegionSuggest(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    suggestions = _useState2[0],
    setSuggestions = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var debouncedInputValue = useDebounce(inputValue, DEBOUNCE_DELAY);
  var inputControlValue = value && 'label' in value ? value.label : inputValue;
  var handleInputChange = function handleInputChange(inputValue) {
    value && onChange('');
    setInputValue(inputValue);
  };
  var handleInputReset = function handleInputReset() {
    value && onChange('');
    setSuggestions([]);
  };
  useEffect(function () {
    if (!debouncedInputValue) return;
    var source = axios.CancelToken.source();
    geoApiService.getGeoSuggest(debouncedInputValue, source.token).then(function (_ref2) {
      var data = _ref2.data;
      setSuggestions(data !== null && data !== void 0 ? data : []);
    }).catch(function (error) {
      if (axios.isCancel(error)) return;
    });
    return source.cancel;
  }, [debouncedInputValue]);
  return React.createElement(Select, null, React.createElement(InputControl, {
    value: inputControlValue,
    onChange: handleInputChange,
    onReset: handleInputReset,
    hasSuggestions: Boolean(suggestions.length)
  }), React.createElement(Select.Content, {
    bounds: true,
    placement: "local"
  }, React.createElement("div", {
    className: styles.suggestions,
    "data-test": "select-region-quiz-suggest-list"
  }, suggestions.map(function (item, index) {
    return React.createElement("div", {
      key: item.value,
      className: styles.suggestion,
      "data-test": "select-region-quiz-suggest-item-".concat(index),
      onClick: function onClick() {
        onChange(item);
        setSuggestions([]);
      }
    }, React.createElement("div", {
      className: styles.suggestionTitle
    }, item.label), item.narrowRegion && React.createElement("div", {
      className: styles.suggestionDescription
    }, item.narrowRegion.name));
  }))));
};